import { getUserHrDocsThunkAction } from "./getUserHrDocs.thunk.action";
import { setCurrentHrDocsThunkAction } from "./setCurrentHrDocs.thunk.action";

import { fetchClaimsThunk } from "../../../User/User Claims/thunk/fetchClaimsThunk";

// import { getUserHrDocsThunkAction } from "./getUserHrDocs.thunk.action";
import $api from "../../../../services/axiosService";
import countly from "../../../../../analytics/countly";
import { EVENT_NAMES } from "../../../../../analytics/events";

export let status;
export const checkStatus = (id, props, documentId, dispatch) => {
    return new Promise((resolve, reject) => {
        const poll = () => {
            setTimeout(async () => {
                try {
                    const resp = await $api(`v2/directum/document/signing/sign/task/${id}`);
                    const data = resp.data;

                    switch (data.status) {
                    case 1:  // в процессе
                    case 0:  // ожидание
                        poll(); // продолжаем опрос
                        break;

                    case 2:  // успех
                        countly.event(EVENT_NAMES.HR_DOCUMENT_SIGNED, { pid: localStorage.getItem("pid") });
                        dispatch(getUserHrDocsThunkAction({ entityType: 0 }));
                        props.setMarkDocuments((prev) => ({
                            ...prev,
                            [documentId]: "Подписание успешно завершено",
                        }));
                        resolve(data); // завершаем Promise успехом
                        break;

                    case 3:
                        status = resp.data.message;
                        props.setMarkDocuments((prev) => {
                            const temp = { ...prev };
                            temp[`${documentId}`] = "Не удалось подписать документ";
                            return temp;
                        });
                        resolve(data);
                        break;
                    case -1: // ошибки
                        props.setMarkDocuments((prev) => ({
                            ...prev,
                            [documentId]: "Не удалось подписать документ",
                        }));
                        resolve(data);
                        // reject(new Error(data.message || "Ошибка подписания"));
                        break;

                    case 4: // требуется УНЭП
                        props.setSignByUnep(data);
                        // Здесь можно либо resolve, либо reject – зависит от логики
                        resolve(data);
                        break;

                    default:
                        return status;
                    }
                } catch (e) {
                    reject(e);
                }
            }, 1000);
        };

        poll(); // запускаем первый опрос
    });
};
// export const checkStatus = async (id, props, documentId, dispatch) => {
//     try {
//         setTimeout(async () => {
//             const resp = await new Promise((resolve, reject) => {
//                 const data = $api(
//                     `v2/directum/document/signing/sign/task/${id}`,
//                 );
//                 resolve(data);
//                 return resp;
//             });
//             // eslint-disable-next-line default-case
//             switch (resp.data.status) {
//             case 3:
//                 status = resp.data.message;
//                 return props.setMarkDocuments((prev) => {
//                     const temp = { ...prev };
//                     temp[`${documentId}`] = "Не удалось подписать документ";
//                     return temp;
//                 });
//             case 1:
//                 return checkStatus(id, props, documentId, dispatch);
//             case 0:
//                 return checkStatus(id, props, documentId,dispatch);
//             case 2:
//                 dispatch(
//                     getUserHrDocsThunkAction({
//                         entityType: 0,
//                     }),
//                 );
//                 return props.setMarkDocuments((prev) => {
//                     const temp = { ...prev };
//                     temp[`${documentId}`] =
//                             " Подписание успешно завершено ";
//                     return temp;
//                 });
//             case 4:
//                 // unep needed
//                 return props.setSignByUnep(resp.data);
//             case -1:
//                 status = resp.data.message;
//                 return props.setMarkDocuments((prev) => {
//                     const temp = { ...prev };
//                     temp[`${documentId}`] = "Не удалось подписать документ";
//                     return temp;
//                 });
//             default:
//                 return status;
//             }
//         }, 1000);
//     } catch (e) {
//         // console.log('signingSignHrDocumentThunkAction ERROR: ', e.response)
//     }
// };
export const signingSignHrDocumentThunkAction =
    (entityType, entityId, documentId, workerId, props) => async (dispatch) => {
        try {
            const currentProps = {
                entityType: entityType,
                entityId: entityId,
                workerId: workerId,
            };
            console.log(currentProps);
            const response = await $api.post(
                "v2/directum/document/signing/sign/task",
                {
                    entityType: entityType,
                    entityId: entityId,
                    documentId: documentId,
                    workerId: workerId,
                },
            );
            if (response.status === 200) {

                await checkStatus(response.data.id, props, documentId, dispatch);
                dispatch(
                    setCurrentHrDocsThunkAction(currentProps.entityId, currentProps.workerId, null, currentProps.entityType),
                );
                dispatch(fetchClaimsThunk());
                // dispatch(getUserHrDocsThunkAction())
            }
        } catch (e) {
            // console.log('signingSignHrDocumentThunkAction ERROR: ', e.response)
        }
    };
